import React from 'react';
import { RotateCcw, Shield, Footprints, ArrowDown } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-[40px] px-0 bg-white" data-id="element-368">
      <div className="container max-w-[800px] mx-auto px-[15px]" data-id="element-369">
        <h2 className="text-[24px] text-center mb-[30px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-370">
          🧠 UNIQUE MECHANISM — THE KNEE GEOMETRY METHOD™
        </h2>

        <div className="flex flex-col gap-4 max-w-[500px] mx-auto" data-id="element-371">
          {/* Step 1 */}
          <div className="bg-[#FEF2F2] border-2 border-[#DC2626] rounded-xl p-6 relative shadow-md" data-id="element-372">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#DC2626] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-373">
              Step 1
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-374">
              <div className="bg-white p-3 rounded-full shadow-sm mb-3 text-[#DC2626]" data-id="element-375">
                <RotateCcw size={32} data-id="element-376" />
              </div>
              <h3 className="text-xl font-bold text-[#991B1B] mb-1" data-id="element-377">
                Reset the Angles
              </h3>
              <p className="text-[#EF4444] font-bold text-sm uppercase mb-2" data-id="element-378">
                Mobility
              </p>
              <p className="text-gray-600" data-id="element-379">
                So first steps don't feel like rusty hinges.
              </p>
            </div>
          </div>

          <ArrowDown className="mx-auto text-[#DC2626]/50" size={32} data-id="element-380" />

          {/* Step 2 */}
          <div className="bg-[#FEF2F2] border-2 border-[#DC2626] rounded-xl p-6 relative shadow-md" data-id="element-381">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#DC2626] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-382">
              Step 2
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-383">
              <div className="bg-white p-3 rounded-full shadow-sm mb-3 text-[#DC2626]" data-id="element-384">
                <Shield size={32} data-id="element-385" />
              </div>
              <h3 className="text-xl font-bold text-[#991B1B] mb-1" data-id="element-386">
                Lock in Stability
              </h3>
              <p className="text-[#EF4444] font-bold text-sm uppercase mb-2" data-id="element-387">
                Safe Strength
              </p>
              <p className="text-gray-600" data-id="element-388">
                So your knee stops feeling wobbly or untrustworthy.
              </p>
            </div>
          </div>

          <ArrowDown className="mx-auto text-[#DC2626]/50" size={32} data-id="element-389" />

          {/* Step 3 */}
          <div className="bg-[#FEF2F2] border-2 border-[#DC2626] rounded-xl p-6 relative shadow-md" data-id="element-390">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#DC2626] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-391">
              Step 3
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-392">
              <div className="bg-white p-3 rounded-full shadow-sm mb-3 text-[#DC2626]" data-id="element-393">
                <Footprints size={32} data-id="element-394" />
              </div>
              <h3 className="text-xl font-bold text-[#991B1B] mb-1" data-id="element-395">
                Train the Walk
              </h3>
              <p className="text-[#EF4444] font-bold text-sm uppercase mb-2" data-id="element-396">
                Balance + Gait
              </p>
              <p className="text-gray-600" data-id="element-397">
                So your nervous system learns: this is safe again.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 bg-[#111827] text-white p-6 rounded-xl text-center shadow-lg mx-auto max-w-[600px]" data-id="element-398">
          <p className="text-lg italic font-medium" data-id="element-399">
            "Most knee problems that limit walking aren't motivation problems.{' '}
            <span className="text-[#FCA5A5] font-bold not-italic" data-id="element-400">
              They're geometry problems.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}